@file:OptIn(InternalResourceApi::class)

package thewedding_cmp.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/thewedding_cmp.composeapp.generated.resources/"

@delegate:ResourceContentHash(-644_909_204)
internal val Res.font.AlexBrush_Regular: FontResource by lazy {
      FontResource("font:AlexBrush_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/AlexBrush-Regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_462_455_589)
internal val Res.font.B612Mono_Regular: FontResource by lazy {
      FontResource("font:B612Mono_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/B612Mono-Regular.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_112_562_263)
internal val Res.font.CinzelDecorative_Black: FontResource by lazy {
      FontResource("font:CinzelDecorative_Black", setOf(
        ResourceItem(setOf(), "${MD}font/CinzelDecorative-Black.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_859_344_522)
internal val Res.font.CinzelDecorative_Bold: FontResource by lazy {
      FontResource("font:CinzelDecorative_Bold", setOf(
        ResourceItem(setOf(), "${MD}font/CinzelDecorative-Bold.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(188_605_254)
internal val Res.font.CinzelDecorative_Regular: FontResource by lazy {
      FontResource("font:CinzelDecorative_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/CinzelDecorative-Regular.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(590_703_594)
internal val Res.font.NotoColorEmoji_Regular: FontResource by lazy {
      FontResource("font:NotoColorEmoji_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/NotoColorEmoji-Regular.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_190_302_311)
internal val Res.font.NotoSans_Bold: FontResource by lazy {
      FontResource("font:NotoSans_Bold", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSans-Bold.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_098_407_928)
internal val Res.font.NotoSans_Regular: FontResource by lazy {
      FontResource("font:NotoSans_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSans-Regular.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_784_032_278)
internal val Res.font.OpenSans_SemiCondensed_Bold: FontResource by lazy {
      FontResource("font:OpenSans_SemiCondensed_Bold", setOf(
        ResourceItem(setOf(), "${MD}font/OpenSans_SemiCondensed-Bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(109_344_423)
internal val Res.font.OpenSans_SemiCondensed_BoldItalic: FontResource by lazy {
      FontResource("font:OpenSans_SemiCondensed_BoldItalic", setOf(
        ResourceItem(setOf(), "${MD}font/OpenSans_SemiCondensed-BoldItalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_983_275_734)
internal val Res.font.OpenSans_SemiCondensed_ExtraBold: FontResource by lazy {
      FontResource("font:OpenSans_SemiCondensed_ExtraBold", setOf(
        ResourceItem(setOf(), "${MD}font/OpenSans_SemiCondensed-ExtraBold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-784_005_634)
internal val Res.font.OpenSans_SemiCondensed_ExtraBoldItalic: FontResource by lazy {
      FontResource("font:OpenSans_SemiCondensed_ExtraBoldItalic", setOf(
        ResourceItem(setOf(), "${MD}font/OpenSans_SemiCondensed-ExtraBoldItalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_956_590_326)
internal val Res.font.OpenSans_SemiCondensed_Italic: FontResource by lazy {
      FontResource("font:OpenSans_SemiCondensed_Italic", setOf(
        ResourceItem(setOf(), "${MD}font/OpenSans_SemiCondensed-Italic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_744_504_364)
internal val Res.font.OpenSans_SemiCondensed_Light: FontResource by lazy {
      FontResource("font:OpenSans_SemiCondensed_Light", setOf(
        ResourceItem(setOf(), "${MD}font/OpenSans_SemiCondensed-Light.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(845_547_558)
internal val Res.font.OpenSans_SemiCondensed_LightItalic: FontResource by lazy {
      FontResource("font:OpenSans_SemiCondensed_LightItalic", setOf(
        ResourceItem(setOf(), "${MD}font/OpenSans_SemiCondensed-LightItalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_416_407_674)
internal val Res.font.OpenSans_SemiCondensed_Medium: FontResource by lazy {
      FontResource("font:OpenSans_SemiCondensed_Medium", setOf(
        ResourceItem(setOf(), "${MD}font/OpenSans_SemiCondensed-Medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(320_937_118)
internal val Res.font.OpenSans_SemiCondensed_MediumItalic: FontResource by lazy {
      FontResource("font:OpenSans_SemiCondensed_MediumItalic", setOf(
        ResourceItem(setOf(), "${MD}font/OpenSans_SemiCondensed-MediumItalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_480_745_022)
internal val Res.font.OpenSans_SemiCondensed_Regular: FontResource by lazy {
      FontResource("font:OpenSans_SemiCondensed_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/OpenSans_SemiCondensed-Regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_735_887_767)
internal val Res.font.OpenSans_SemiCondensed_SemiBold: FontResource by lazy {
      FontResource("font:OpenSans_SemiCondensed_SemiBold", setOf(
        ResourceItem(setOf(), "${MD}font/OpenSans_SemiCondensed-SemiBold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_770_361_223)
internal val Res.font.OpenSans_SemiCondensed_SemiBoldItalic: FontResource by lazy {
      FontResource("font:OpenSans_SemiCondensed_SemiBoldItalic", setOf(
        ResourceItem(setOf(), "${MD}font/OpenSans_SemiCondensed-SemiBoldItalic.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(30_807_428)
internal val Res.font.Raleway_Bold: FontResource by lazy {
      FontResource("font:Raleway_Bold", setOf(
        ResourceItem(setOf(), "${MD}font/Raleway-Bold.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-969_941_736)
internal val Res.font.Raleway_BoldItalic: FontResource by lazy {
      FontResource("font:Raleway_BoldItalic", setOf(
        ResourceItem(setOf(), "${MD}font/Raleway-BoldItalic.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(968_674_529)
internal val Res.font.Raleway_ExtraBold: FontResource by lazy {
      FontResource("font:Raleway_ExtraBold", setOf(
        ResourceItem(setOf(), "${MD}font/Raleway-ExtraBold.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(831_917_858)
internal val Res.font.Raleway_ExtraBoldItalic: FontResource by lazy {
      FontResource("font:Raleway_ExtraBoldItalic", setOf(
        ResourceItem(setOf(), "${MD}font/Raleway-ExtraBoldItalic.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(561_725_217)
internal val Res.font.Raleway_Italic: FontResource by lazy {
      FontResource("font:Raleway_Italic", setOf(
        ResourceItem(setOf(), "${MD}font/Raleway-Italic.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-247_038_726)
internal val Res.font.Raleway_Medium: FontResource by lazy {
      FontResource("font:Raleway_Medium", setOf(
        ResourceItem(setOf(), "${MD}font/Raleway-Medium.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_913_885_474)
internal val Res.font.Raleway_MediumItalic: FontResource by lazy {
      FontResource("font:Raleway_MediumItalic", setOf(
        ResourceItem(setOf(), "${MD}font/Raleway-MediumItalic.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(47_140_712)
internal val Res.font.Raleway_Regular: FontResource by lazy {
      FontResource("font:Raleway_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/Raleway-Regular.woff2", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_204_705_136)
internal val Res.font.YesevaOne_Regular: FontResource by lazy {
      FontResource("font:YesevaOne_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/YesevaOne-Regular.woff2", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("AlexBrush_Regular", Res.font.AlexBrush_Regular)
  map.put("B612Mono_Regular", Res.font.B612Mono_Regular)
  map.put("CinzelDecorative_Black", Res.font.CinzelDecorative_Black)
  map.put("CinzelDecorative_Bold", Res.font.CinzelDecorative_Bold)
  map.put("CinzelDecorative_Regular", Res.font.CinzelDecorative_Regular)
  map.put("NotoColorEmoji_Regular", Res.font.NotoColorEmoji_Regular)
  map.put("NotoSans_Bold", Res.font.NotoSans_Bold)
  map.put("NotoSans_Regular", Res.font.NotoSans_Regular)
  map.put("OpenSans_SemiCondensed_Bold", Res.font.OpenSans_SemiCondensed_Bold)
  map.put("OpenSans_SemiCondensed_BoldItalic", Res.font.OpenSans_SemiCondensed_BoldItalic)
  map.put("OpenSans_SemiCondensed_ExtraBold", Res.font.OpenSans_SemiCondensed_ExtraBold)
  map.put("OpenSans_SemiCondensed_ExtraBoldItalic", Res.font.OpenSans_SemiCondensed_ExtraBoldItalic)
  map.put("OpenSans_SemiCondensed_Italic", Res.font.OpenSans_SemiCondensed_Italic)
  map.put("OpenSans_SemiCondensed_Light", Res.font.OpenSans_SemiCondensed_Light)
  map.put("OpenSans_SemiCondensed_LightItalic", Res.font.OpenSans_SemiCondensed_LightItalic)
  map.put("OpenSans_SemiCondensed_Medium", Res.font.OpenSans_SemiCondensed_Medium)
  map.put("OpenSans_SemiCondensed_MediumItalic", Res.font.OpenSans_SemiCondensed_MediumItalic)
  map.put("OpenSans_SemiCondensed_Regular", Res.font.OpenSans_SemiCondensed_Regular)
  map.put("OpenSans_SemiCondensed_SemiBold", Res.font.OpenSans_SemiCondensed_SemiBold)
  map.put("OpenSans_SemiCondensed_SemiBoldItalic", Res.font.OpenSans_SemiCondensed_SemiBoldItalic)
  map.put("Raleway_Bold", Res.font.Raleway_Bold)
  map.put("Raleway_BoldItalic", Res.font.Raleway_BoldItalic)
  map.put("Raleway_ExtraBold", Res.font.Raleway_ExtraBold)
  map.put("Raleway_ExtraBoldItalic", Res.font.Raleway_ExtraBoldItalic)
  map.put("Raleway_Italic", Res.font.Raleway_Italic)
  map.put("Raleway_Medium", Res.font.Raleway_Medium)
  map.put("Raleway_MediumItalic", Res.font.Raleway_MediumItalic)
  map.put("Raleway_Regular", Res.font.Raleway_Regular)
  map.put("YesevaOne_Regular", Res.font.YesevaOne_Regular)
}
